/**
 * Modal Footer Component.
 *
 * @author Ryan Johnston <ryan.johnston@scalesology.com>
 */
import React, { Component } from 'react';

import childrenPropType from 'js/PropTypes/children';

/**
 * Modal Footer
 */
class ModalFooter extends Component {
    static propTypes = {
        children: childrenPropType,
    };

    static defaultProps = {
        children: null,
    };

    /**
     * Render modal footer.
     *
     * @returns {React.node}
     */
    render() {
        const { children } = this.props;

        return (
            <div className="modal-footer">
                {children}
            </div>
        );
    }
}

export default ModalFooter;
